import { render, staticRenderFns } from "./HorBarItem_textUp.vue?vue&type=template&id=6a34e82a&scoped=true"
import script from "./HorBarItem_textUp.vue?vue&type=script&lang=js"
export * from "./HorBarItem_textUp.vue?vue&type=script&lang=js"
import style0 from "./HorBarItem_textUp.vue?vue&type=style&index=0&id=6a34e82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34e82a",
  null
  
)

export default component.exports